import client from "./client";

export const getMainInfo = (
    corprInfoDiviNo,
    stdYear,
    admnNo
) =>
    client.get('/kognr/mainInfo', {
        params: {
            corprInfoDiviNo,
            stdYear,
            admnNo
        }
    });

export const saveMainInfo = (mainInfo) => client.post("/kognr/mainInfo", {
    ...mainInfo
})

export const findTmpContByAdmnNo = (
    admnNo
) =>
    client.get('/kognr/tmpCont', {
        params: {
            admnNo
        }
    });


// 직전년도 부양가족정보 조회
export const findFamilyInfo = (stdYear, corprInfoDiviNo, citizno) =>
  client.get("/kognr/family", {
    params: {
      stdYear,
      corprInfoDiviNo,
      citizno
    }
  });

